module.exports = __webpack_public_path__ + "images/colorful-21a020704c681f93ee819e434d1fb123.jpg";